import { AxiosResponse } from 'axios';
import {
    ICard,
    ICardForm,
    ICardSpendStats,
    IClientCardHistory,
    ITemplate,
} from '@entities/card/types';
import { api, API_URL } from '@api/config';
import {
    IBaseQuery,
    ICartTrnsaction,
    IOkResponse,
    PaginatedType,
} from '@types';
import { ICreateRegForm } from '@api/services/cardApi/types';

const BASE_PATH = 'shops';

export const getClientCardTransactReq = (
    id: number,
    shop_id: number,
    params: IBaseQuery
): Promise<AxiosResponse<PaginatedType<IClientCardHistory>>> => {
    return api.get<PaginatedType<IClientCardHistory>>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/clients/${id}/cards/history/transactions`,
        {
            params: {
                ...params,
            },
        }
    );
};

export const getClientCardChangesReq = (
    id: number,
    shop_id: number,
    params: IBaseQuery
): Promise<AxiosResponse<PaginatedType<IClientCardHistory>>> => {
    return api.get<PaginatedType<IClientCardHistory>>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/clients/${id}/cards/history/changes`,
        {
            params: {
                ...params,
            },
        }
    );
};

export const getClientCardReq = (
    id: number,
    shop_id: number
): Promise<AxiosResponse<ICard[]>> => {
    return api.get<ICard[]>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/clients/${id}/cards`
    );
};

export const bonusInRequest = (
    id: number,
    shop_id: number,
    amount: number
): Promise<AxiosResponse<ICartTrnsaction>> => {
    return api.post<ICartTrnsaction>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/cards/${id}/bonus-in`,
        { amount }
    );
};

export const bonusOutRequest = (
    id: number,
    shop_id: number,
    amount: number
): Promise<AxiosResponse<ICartTrnsaction>> => {
    return api.post<ICartTrnsaction>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/cards/${id}/bonus-out`,
        { amount }
    );
};
export const getCardSpendStatsRequest = (
    card_id: number,
    shop_id: number,
    client_id: number
): Promise<AxiosResponse<ICardSpendStats>> => {
    return api.get<ICardSpendStats>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/clients/${client_id}/cards/${card_id}/spendStats`
    );
};

export const getAllCardsSpendStatsRequest = (
    shop_id: number,
    client_id: number
): Promise<AxiosResponse<ICardSpendStats>> => {
    return api.get<ICardSpendStats>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/clients/${client_id}/cards/spendStats`
    );
};

export const getCardtemplatesRequest = (shop_id: number) => {
    return api.get<ITemplate[]>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/card-templates/short-list`
    );
};

export const getCardFormRequest = (
    shop_id: number
): Promise<AxiosResponse<ICardForm[]>> => {
    return api.get<ICardForm[]>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/reg-forms`
    );
};

export const blockCardRequest = (
    id: number,
    shop_id: number,
    message: string
): Promise<AxiosResponse<IOkResponse>> => {
    return api.post<IOkResponse>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/cards/${id}/lock`,
        { message }
    );
};

export const unlockCardRequest = (
    id: number,
    shop_id: number
): Promise<AxiosResponse<IOkResponse>> => {
    return api.post<IOkResponse>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/cards/${id}/unlock`
    );
};

export const changeCardTemplateRequest = (
    id: number,
    shop_id: number,
    template_id: number
): Promise<AxiosResponse<IOkResponse>> => {
    return api.post<IOkResponse>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/cards/${id}/change-template`,
        { template_id }
    );
};

export const createRegFormRequest = async (
    shop_id: number,
    data: ICreateRegForm
): Promise<AxiosResponse<IOkResponse>> => {
    return await api.post<IOkResponse>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/reg-forms`,
        data
    );
};

export const updateFormRequest = async (
    shop_id: number,
    form_id: React.Key,
    data: ICreateRegForm
): Promise<AxiosResponse<IOkResponse>> => {
    return await api.post<IOkResponse>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/reg-forms/${form_id}`,
        data
    );
};

export const deleteFormRequest = async (
    shop_id: number,
    form_id: React.Key
): Promise<AxiosResponse<IOkResponse>> => {
    return await api.delete<IOkResponse>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/reg-forms/${form_id}`
    );
};

export const disableFormRequest = async (
    shop_id: number,
    form_id: React.Key
): Promise<AxiosResponse<IOkResponse>> => {
    return await api.post<IOkResponse>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/reg-forms/${form_id}/disable`
    );
};

export const enableFormRequest = async (
    shop_id: number,
    form_id: React.Key
): Promise<AxiosResponse<IOkResponse>> => {
    return await api.post<IOkResponse>(
        `${API_URL}/${BASE_PATH}/${shop_id}/loyalty/reg-forms/${form_id}/enable`
    );
};
